import {
  COLOR_PRIMARY,
  COLOR_PRIMARY_CONTRAST,
  COLOR_SECONDARY,
  COLOR_SECONDARY_CONTRAST,
  COLOR_SIDEBAR,
  COLOR_SIDEBAR_CONTRAST,
  COLOR_LINK,
} from "../../models/CustomerPreferencesBranding";

const customersCheckoutBranding = {
  colors: {
    [COLOR_PRIMARY]: "Primary color",
    [COLOR_PRIMARY_CONTRAST]: "Primary text color",
    [COLOR_SECONDARY]: "Secondary color",
    [COLOR_SECONDARY_CONTRAST]: "Secondary text color",
    [COLOR_SIDEBAR]: "Sidebar color",
    [COLOR_SIDEBAR_CONTRAST]: "Sidebar text color",
    [COLOR_LINK]: "Link text color",
  },
  "default color": "{{color}} (default)",
};

export default customersCheckoutBranding;
